import { render, staticRenderFns } from "./newPlatimg.vue?vue&type=template&id=5074f8bb&scoped=true&"
import script from "./newPlatimg.vue?vue&type=script&lang=js&"
export * from "./newPlatimg.vue?vue&type=script&lang=js&"
import style0 from "./newPlatimg.vue?vue&type=style&index=0&id=5074f8bb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5074f8bb",
  null
  
)

export default component.exports